import React from 'react';
import Planes from '../components/Planes/Planes'

export default function AgendarCitaPage() {
  return (
    <div className="form-section">
      <Planes />
    </div>
  );
}